import { Navigate, useRoutes } from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard";
import SimpleLayout from "./layouts/simple";
//
import BlogPage from "./pages/BlogPage";
import UserPage from "./pages/UserPage";
import LoginPage from "./pages/LoginPage";
import Page404 from "./pages/Page404";
import ProductsPage from "./pages/ProductsPage";
import DashboardAppPage from "./pages/DashboardAppPage";
import GameQuestionsPage from "./pages/GameQuestionsPage";
import GameUsersPage from "./pages/GameUsersPage";
import GameUserCardPage from "./pages/GameUserCardPage";
import GameQuestionCreatePage from "./pages/GameQuestionCreatePage";
import GameResultsPage from "./pages/GameResultsPage";
import QuestionTemplatesPage from "./pages/QuestionTemplatesPage";
import TeamsPage from "./pages/TeamsPage";
import SeriesResultsPage from "./pages/SeriesResultsPage";
import CustomLeaguesPage from "./pages/CustomLeaguesPage";
import DashboardPage from "./pages/DashboardPage";
import MatchesPage from "./pages/MatchesPage";
import ConferencesPage from "./pages/ConferencesPage";
import NewConferencePage from "./pages/NewConferencePage";
import RoundsPage from "./pages/RoundsPage";
import NewRoundPage from "./pages/NewRoundPage";
import NewTeamPage from "./pages/NewTeamPage";
import EditMatchPage from "./pages/EditMatchPage";
import EditConferencePage from "./pages/EditConferencePage";
import EditRoundPage from "./pages/EditRoundPage";
import EditTeamPage from "./pages/EditTeamPage";
import BracketSettingPage from "./pages/BracketSettingPage";
import ResultMatchPage from "./pages/ResultMatchPage";
import LeaguesPage from "./pages/LeaguesPage";
import NewLeaguePage from "./pages/NewLeaguePage";
import EditLeaguePage from "./pages/EditLeaguePage";
import PagesList from "./pages/PagesList";
import PageEditPage from "./pages/PageEditPage";
import LeaderboardPage from "./pages/LeaderboardPage";

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/games" />, index: true },
        { path: "bracket-setting", element: <BracketSettingPage /> },
        { path: "leagues", element: <LeaguesPage /> },
        { path: "new-league", element: <NewLeaguePage /> },
        { path: "edit-league", element: <EditLeaguePage /> },
        { path: "conferences", element: <ConferencesPage /> },
        { path: "new-conference", element: <NewConferencePage /> },
        { path: "edit-conference", element: <EditConferencePage /> },
        { path: "rounds", element: <RoundsPage /> },
        { path: "new-round", element: <NewRoundPage /> },
        { path: "edit-round", element: <EditRoundPage /> },
        { path: "teams", element: <TeamsPage /> },
        { path: "new-team", element: <NewTeamPage /> },
        { path: "edit-team", element: <EditTeamPage /> },
        { path: "matches", element: <MatchesPage /> },
        { path: "edit-match", element: <EditMatchPage /> },
        { path: "set-result-match", element: <ResultMatchPage /> },
        { path: "series-results", element: <SeriesResultsPage /> },
        { path: "question-templates", element: <QuestionTemplatesPage /> },
        { path: "game/dashboard", element: <DashboardPage /> },
        { path: "game/questions", element: <GameQuestionsPage /> },
        { path: "game/questions/create", element: <GameQuestionCreatePage /> },
        { path: "game/users", element: <GameUsersPage /> },
        { path: "game/results", element: <GameResultsPage /> },
        { path: "game/user-card", element: <GameUserCardPage /> },
        { path: "leagues", element: <CustomLeaguesPage /> },
        { path: "app", element: <DashboardAppPage /> },
        { path: "user", element: <UserPage /> },
        { path: "products", element: <ProductsPage /> },
        { path: "blog", element: <BlogPage /> },
        { path: "pages", element: <PagesList /> },
        { path: "pages/edit", element: <PageEditPage /> },
        { path: "leaderboard", element: <LeaderboardPage />}
      ],
    },
    {
      path: "login",
      element: <LoginPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/matches?type=men" />, index: true },
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
